import { useUser, useBasket } from "../../providers"
import Layout from "./Layout"

export default function Order(props) {
  const { user } = useUser()
  const { basket: orders } = useBasket()

  const layoutProps = {
    ...props,
    orders,
    user,
  }

  return <Layout {...layoutProps} />
}
